module.exports = "<city-page></city-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/city.html
// module id = 1550
// module chunks = 0